import styled from "@emotion/styled";
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
  FacebookIcon,
  TwitterIcon,
  PinterestIcon
} from "react-share";

import { Flex, Box } from "@herb/ui";
import { Instagram } from "@material-ui/icons";
const isBrowser = typeof window !== "undefined";

const SocialIcons = styled(Flex)`
  [role="button"] {
    cursor: pointer;
  }
`;

const ShareIcons = ({ url, media, article, ...props }) => {
  return (
    <SocialIcons alignItems="center" justifyContent={"flex-start"} {...props}>
      <Box className="share-icon">
        <a
          href="https://www.instagram.com/herb/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="react-share__ShareButton custom-share-button">
            <div className="mobile-only">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.96975 1.64442C8.57794 1.64621 9.16069 1.88502 9.59074 2.30871C10.0208 2.7324 10.2632 3.30652 10.265 3.9057V8.42778C10.2632 9.02696 10.0208 9.60109 9.59074 10.0248C9.16069 10.4485 8.57794 10.6873 7.96975 10.6891H3.37972C2.77154 10.6873 2.18879 10.4485 1.75873 10.0248C1.32868 9.60109 1.08628 9.02696 1.08446 8.42778V3.9057C1.08628 3.30652 1.32868 2.7324 1.75873 2.30871C2.18879 1.88502 2.77154 1.64621 3.37972 1.64442H7.96975ZM7.96975 0.740051H3.37972C1.61242 0.740051 0.166504 2.16456 0.166504 3.9057V8.42778C0.166504 10.1689 1.61242 11.5934 3.37972 11.5934H7.96975C9.73706 11.5934 11.183 10.1689 11.183 8.42778V3.9057C11.183 2.16456 9.73706 0.740051 7.96975 0.740051Z"
                  fill="black"
                />
                <path
                  d="M8.65807 3.90571C8.52189 3.90571 8.38877 3.86593 8.27555 3.79139C8.16232 3.71686 8.07407 3.61092 8.02195 3.48697C7.96984 3.36302 7.95621 3.22663 7.98277 3.09504C8.00934 2.96346 8.07492 2.84259 8.17121 2.74772C8.2675 2.65286 8.39019 2.58825 8.52375 2.56208C8.65731 2.5359 8.79575 2.54934 8.92156 2.60068C9.04737 2.65202 9.15491 2.73896 9.23056 2.85051C9.30622 2.96207 9.3466 3.09322 9.3466 3.22738C9.3468 3.31651 9.32912 3.40481 9.29459 3.48719C9.26005 3.56958 9.20935 3.64443 9.14537 3.70746C9.0814 3.77049 9.00542 3.82045 8.92179 3.85447C8.83817 3.88849 8.74855 3.90591 8.65807 3.90571ZM5.67453 4.35778C6.03769 4.35778 6.39269 4.46387 6.69464 4.66265C6.9966 4.86142 7.23194 5.14394 7.37092 5.47449C7.50989 5.80504 7.54626 6.16876 7.47541 6.51967C7.40456 6.87058 7.22968 7.19291 6.97289 7.4459C6.7161 7.69889 6.38893 7.87117 6.03275 7.94097C5.67656 8.01077 5.30737 7.97495 4.97186 7.83803C4.63635 7.70112 4.34958 7.46925 4.14782 7.17177C3.94606 6.87428 3.83837 6.52454 3.83837 6.16676C3.83889 5.68714 4.03251 5.22732 4.37674 4.88818C4.72098 4.54904 5.18771 4.35829 5.67453 4.35778ZM5.67453 3.45341C5.12982 3.45341 4.59734 3.61254 4.14442 3.91069C3.69151 4.20884 3.33851 4.6326 3.13006 5.1284C2.9216 5.6242 2.86706 6.16977 2.97333 6.6961C3.0796 7.22244 3.3419 7.70591 3.72707 8.08538C4.11224 8.46485 4.60298 8.72327 5.13723 8.82797C5.67147 8.93266 6.22523 8.87893 6.72848 8.67356C7.23173 8.46819 7.66187 8.12042 7.96449 7.67421C8.26712 7.228 8.42865 6.7034 8.42865 6.16676C8.42865 5.44713 8.13848 4.75698 7.62198 4.24813C7.10549 3.73928 6.40497 3.45341 5.67453 3.45341Z"
                  fill="black"
                />
              </svg>
            </div>
            <div className="desktop-only">
              <svg
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.7026 2.22811C21.2009 2.23252 22.6367 2.82089 23.6962 3.86473C24.7557 4.90858 25.353 6.32306 25.3574 7.79927V18.9404C25.353 20.4166 24.7557 21.8311 23.6962 22.8749C22.6367 23.9188 21.2009 24.5072 19.7026 24.5116H8.39401C6.89562 24.5072 5.45987 23.9188 4.40035 22.8749C3.34082 21.8311 2.7436 20.4166 2.73913 18.9404V7.79927C2.7436 6.32306 3.34082 4.90858 4.40035 3.86473C5.45987 2.82089 6.89562 2.23252 8.39401 2.22811H19.7026ZM19.7026 0H8.39401C4.03986 0 0.477539 3.50958 0.477539 7.79927V18.9404C0.477539 23.2301 4.03986 26.7397 8.39401 26.7397H19.7026C24.0567 26.7397 27.619 23.2301 27.619 18.9404V7.79927C27.619 3.50958 24.0567 0 19.7026 0Z"
                  fill="black"
                />
                <path
                  d="M21.3987 7.79925C21.0632 7.79925 20.7352 7.70123 20.4562 7.5176C20.1773 7.33396 19.9599 7.07295 19.8315 6.76757C19.7031 6.46219 19.6695 6.12616 19.7349 5.80198C19.8004 5.47779 19.962 5.18001 20.1992 4.94628C20.4364 4.71255 20.7387 4.55338 21.0677 4.4889C21.3968 4.42442 21.7379 4.45751 22.0478 4.584C22.3578 4.71049 22.6227 4.9247 22.8091 5.19953C22.9955 5.47436 23.095 5.79748 23.095 6.12802C23.0955 6.34762 23.052 6.56515 22.9669 6.76813C22.8818 6.9711 22.7569 7.15553 22.5993 7.31081C22.4416 7.46609 22.2544 7.58918 22.0484 7.673C21.8424 7.75681 21.6216 7.79972 21.3987 7.79925ZM14.0481 8.913C14.9428 8.913 15.8174 9.17439 16.5613 9.66411C17.3053 10.1538 17.8851 10.8499 18.2275 11.6643C18.5699 12.4786 18.6595 13.3748 18.4849 14.2393C18.3104 15.1038 17.8795 15.898 17.2469 16.5213C16.6142 17.1446 15.8081 17.569 14.9306 17.741C14.0531 17.913 13.1435 17.8247 12.3169 17.4874C11.4903 17.1501 10.7838 16.5788 10.2867 15.8459C9.7896 15.113 9.52429 14.2513 9.52429 13.3698C9.52557 12.1882 10.0026 11.0553 10.8507 10.2198C11.6988 9.38423 12.8487 8.91427 14.0481 8.913ZM14.0481 6.6849C12.706 6.6849 11.3942 7.07696 10.2783 7.81151C9.16247 8.54606 8.29277 9.5901 7.7792 10.8116C7.26564 12.0331 7.13126 13.3772 7.39308 14.674C7.65489 15.9707 8.30114 17.1619 9.25009 18.0968C10.199 19.0317 11.4081 19.6684 12.7243 19.9263C14.0405 20.1842 15.4049 20.0518 16.6447 19.5459C17.8846 19.0399 18.9443 18.1831 19.6899 17.0838C20.4355 15.9844 20.8334 14.692 20.8334 13.3698C20.8334 11.5969 20.1186 9.89653 18.8461 8.64286C17.5735 7.3892 15.8477 6.6849 14.0481 6.6849Z"
                  fill="black"
                />
              </svg>
            </div>
          </button>
        </a>
      </Box>
      <Box className="share-icon">
        <FacebookShareButton
          url={`https://herb.co${url}`}
          additionalprops={{ "aria-label": "Share on Facebook" }}
        >
          <div className="mobile-only">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.3574 6.1668C11.3574 3.16997 8.89096 0.740051 5.84911 0.740051C2.80725 0.740051 0.34082 3.16997 0.34082 6.1668C0.34082 8.87532 2.35479 11.1204 4.98844 11.5279V7.73595H3.58948V6.1668H4.98844V4.97122C4.98844 3.61138 5.81099 2.85963 7.06905 2.85963C7.67176 2.85963 8.30226 2.96574 8.30226 2.96574V4.30135H7.60733C6.92347 4.30135 6.70953 4.7195 6.70953 5.14928V6.1668H8.2371L7.99316 7.73595H6.70978V11.5284C9.34343 11.1211 11.3574 8.87605 11.3574 6.1668Z"
                fill="black"
              />
            </svg>
          </div>
          <div className="desktop-only">
            <svg
              width="28"
              height="27"
              viewBox="0 0 28 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.5412 13.37C27.5412 5.98665 21.4646 0 13.9703 0C6.47602 0 0.399414 5.98665 0.399414 13.37C0.399414 20.043 5.36126 25.5743 11.8498 26.5782V17.2359H8.4032V13.37H11.8498V10.4244C11.8498 7.07415 13.8764 5.22205 16.9759 5.22205C18.4608 5.22205 20.0142 5.48348 20.0142 5.48348V8.77405H18.3021C16.6172 8.77405 16.0901 9.80425 16.0901 10.8631V13.37H19.8536L19.2526 17.2359H16.0907V26.5794C22.5793 25.576 27.5412 20.0448 27.5412 13.37Z"
                fill="black"
              />
            </svg>
          </div>
        </FacebookShareButton>
      </Box>
      <Box className="share-icon">
        <TwitterShareButton
          url={`https://herb.co${url}`}
          additionalprops={{ "aria-label": "Share on Twitter" }}
        >
          <div className="mobile-only">
            <svg
              width="14"
              height="11"
              viewBox="0 0 14 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.7263 1.41498C13.2308 1.62711 12.7065 1.76687 12.17 1.82983C12.7338 1.50456 13.1578 0.987799 13.3625 0.376476C12.8294 0.683576 12.2472 0.899053 11.6407 1.01368C11.3853 0.749991 11.0782 0.540224 10.7379 0.397122C10.3977 0.254021 10.0315 0.180575 9.66157 0.181248C8.1638 0.181248 6.95172 1.35803 6.95172 2.80868C6.95066 3.01046 6.97413 3.21164 7.02163 3.40792C5.94762 3.35832 4.89595 3.08839 3.93389 2.61542C2.97184 2.14245 2.12058 1.47684 1.4346 0.661182C1.19393 1.06089 1.06666 1.51694 1.06607 1.98168C1.06607 2.89274 1.54854 3.69805 2.27705 4.16985C1.84543 4.15976 1.42265 4.04721 1.0446 3.84176V3.8743C1.0446 5.14869 1.98036 6.20889 3.21887 6.45021C2.98597 6.51138 2.74597 6.54237 2.50494 6.5424C2.33391 6.54269 2.16327 6.52634 1.9955 6.49359C2.3398 7.53752 3.34189 8.29673 4.52893 8.31843C3.56438 9.05078 2.38016 9.4466 1.1624 9.44369C0.946244 9.44338 0.73029 9.4307 0.515625 9.40573C1.75445 10.1851 3.19449 10.5973 4.66434 10.5934C9.65579 10.5934 12.3827 6.58849 12.3827 3.11508C12.3827 3.0012 12.3797 2.88731 12.3742 2.77614C12.9034 2.40523 13.3613 1.94429 13.7263 1.41498Z"
                fill="black"
              />
            </svg>
          </div>
          <div className="desktop-only">
            <svg
              width="33"
              height="26"
              viewBox="0 0 33 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.8688 3.12654C31.6479 3.64918 30.3561 3.99351 29.0343 4.14864C30.4234 3.34725 31.4681 2.0741 31.9724 0.567971C30.659 1.32458 29.2245 1.85545 27.7303 2.13785C27.1012 1.48821 26.3444 0.9714 25.5062 0.618839C24.668 0.266277 23.7657 0.0853268 22.8543 0.0869864C19.1642 0.0869864 16.178 2.98626 16.178 6.56024C16.1754 7.05737 16.2332 7.55302 16.3502 8.0366C13.7042 7.91439 11.1132 7.24937 8.74294 6.0841C6.37271 4.91883 4.27546 3.27896 2.58537 1.26941C1.99245 2.25417 1.67888 3.37775 1.67743 4.52274C1.67743 6.76733 2.8661 8.7514 4.66095 9.91378C3.59755 9.88891 2.55594 9.61162 1.62454 9.10545V9.18562C1.62454 12.3254 3.92999 14.9374 6.98132 15.5319C6.40752 15.6826 5.81623 15.759 5.2224 15.7591C4.80103 15.7598 4.38062 15.7195 3.96729 15.6388C4.81555 18.2108 7.28442 20.0813 10.2089 20.1347C7.83256 21.939 4.91497 22.9142 1.91476 22.907C1.38221 22.9063 0.850162 22.875 0.321289 22.8135C3.37342 24.7336 6.92127 25.7492 10.5426 25.7395C22.8401 25.7395 29.5584 15.8726 29.5584 7.31512C29.5584 7.03455 29.551 6.75397 29.5374 6.48008C30.8414 5.56625 31.9695 4.43062 32.8688 3.12654Z"
                fill="black"
              />
            </svg>
          </div>
        </TwitterShareButton>
      </Box>
    </SocialIcons>
  );
};

export default ShareIcons;
